import { createSelector } from "@reduxjs/toolkit";
import * as con from "../../GlobalConstants.js";

const selectPeriodicity = state =>
    state[con.MODEL_PARAMETERS][con.PERIODICITY];

const selectTermPeriodicity = state =>
    state[con.MODEL_PARAMETERS][con.TERM_PERIODICITY];

export const selectTermInMonths = createSelector(
    [selectPeriodicity, selectTermPeriodicity],
    (periodicity, term_periodicity) => {

        if (periodicity === con.PERIODICITY_MONTH)
            return term_periodicity;

        if (periodicity === con.PERIODICITY_WEEK)
            return Math.ceil(term_periodicity / 4);

        if (periodicity === con.PERIODICITY_DAY)
            return Math.ceil(term_periodicity / 30);

        return 0;
    }
);